import {
  RouteRef,
  SubRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  segments = 'segments',
  segment = 'segment',
}

// Internal route refs (used by this plugin's routable extension)
export const segmentsRouteRef = createRouteRef({
  id: RoutesIds.segments,
});
export const rootRouteRef = segmentsRouteRef;

export const segmentRouteRef = createSubRouteRef({
  id: RoutesIds.segment,
  parent: rootRouteRef,
  path: '/:id',
});

export const Routes = {
  segments: segmentsRouteRef,
  segment: segmentRouteRef,
} satisfies Record<RoutesIds, RouteRef | SubRouteRef>;
